<template>
  <div class="questions__panel" v-show="questionsList.length > 0">
  <!-- <div class="questions__panel"> -->
    <p class="quesion__title">用户问答</p>
    <ul v-if="questionsList.length > 0">
      <li v-for="question in questionsList" :key="question.msg_id">
        <span class="question__tap">学员 <i>{{transformDate(question.create_time)}}</i></span>
        <p class="question__content">{{question.msg}}</p>
        <ul v-if="question.child.length > 0">
          <li v-for="answer in question.child" :key="answer.msg_id">
            <span class="question__tap">老师 <i>{{transformDate(answer.create_time)}}</i></span>
            <el-input
              maxlength="500"
              style="resize:none;"
              class="textarea_custom"
              type="textarea"
              :rows="2"
              autosize
              placeholder="请输入回复"
              @blur="saveAnswer(answer.msg_id, answer.pid, answer.msg)"
              v-model="answer.msg">
            </el-input>
          </li>
        </ul>
      </li>
    </ul>
    <el-input
      maxlength="500"
      class="qtextarea"
      type="textarea"
      :rows="2"
      autosize
      placeholder="请输入回复"
      v-model="answerMsg.msg">
    </el-input>
    <p class="no_reply" v-if='isshow' @click='unreply()'>暂不回复</p>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      questionsList: [],
      isshow: this.$route.params.is_new == 1
    }
  },
  computed: {
    answerMsg: {
      get () {
        return this.$store.state.app.answerMsg
      },
      set (value) {
        this.$store.commit('setAnswerMsg', value)
      }
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.params.exercise_id || this.$route.params.record_id || this.$route.params.question_id || this.$route.params.object_type) {
        this.getUserMsg()
      }
    }
  },
  created () {
    this.getUserMsg()
  },
  methods: {
    getUserMsg () {
      this.answerMsg.msg = ''
      console.log(this.$route.params)
      const { exercise_id, record_id, comment_object_id, object_type } = this.$route.params
      let params = {
        exercise_id: exercise_id,
        record_id: record_id,
        question_id: comment_object_id,
        object_type: object_type,
        correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
      }
      // let params = {
      //   exercise_id: 1,
      //   record_id: 1,
      //   question_id: 1,
      //   object_type: 1
      // }
      this.$api.GETUSERMSG(params).then((res) => {
        if (res.retcode === 0) {
          this.questionsList = res.data
          this.answerMsg.msg_pid = this.questionsList[this.questionsList.length - 1].msg_id
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    saveAnswer (msgId, pid, msg) {
      let params = {
        msg_id: msgId,
        msg_pid: pid,
        msg: msg,
        correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
      }
      this.$api.REPLYMSG(params).then((res) => {
      }).catch((err) => {
        console.log(err)
      })
    },
    transformDate (d) {
      if (!d) {
        return
      }
      const now = new Date()
      const year = now.getFullYear()
      const newDate = moment(d * 1000).format('YYYY年MM月DD日 HH:mm:ss')
      if (String(year) === newDate.substr(0, 4)) {
        return newDate.substring(5)
      }
      return newDate
    },
    unreply () {
      this.$api.PAUSEREPLYMSG({
        msg_id: this.answerMsg.msg_pid
      }).then((res) => {
        if (res.retcode == 0) {
          this.isshow = false
          location.reload()
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.questions__panel{
  padding-top: 14px;
  p.quesion__title{
    font-size: 14px;
    line-height: 14px;
    color: #2a2e3d;
    font-weight: bold;
    background: url("./img/icon.png") no-repeat;
    padding-left: 14px;
  }
  ul{
    list-style-type: none;
    padding: 0;
    li{
      .question__tap{
        font-size: 14px;
        color: #2a2e3d;
        display: inline-block;
        padding-bottom: 3px;
        i{
          font-style: normal;
        }
      }
      .question__content{
        font-size: 12px;
        color: #7d829a;
        padding: 0;
        margin: 0;
        line-height: 21px;
      }
      .question__content_text{
        font-size: 12px;
        color: #7d829a;
        font-family: inherit;
        display: block;
        width: 100%;
        height: 25px;
        max-height: auto;
        border: 0;
        resize: none;
      }
    }
  }
  .no_reply {
    font-size: 14px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/questions/index.vue